<template>
<div id="mc_embed_signup">
  <form action="https://2pt.us19.list-manage.com/subscribe/post?u=93ba7ce80c06f71e6322695a0&amp;id=eecb319e1a" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
      <div id="mc_embed_signup_scroll">
    <label for="mce-EMAIL">Subscribe to Pogocat Updates</label>
    <input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="Email" required>
      <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
      <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_93ba7ce80c06f71e6322695a0_eecb319e1a" tabindex="-1" value=""></div>
      <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button"></div>
      </div>
  </form>
</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
#mc_embed_signup {
  clear: left;
  width: 100%;
  padding: 32px 0px 32px 0px;
}
#mc-embedded-subscribe-form input[type="checkbox"] {
  display: inline;
  margin-right: 10px;
}
#mc-embedded-subscribe-form .mc_fieldset {
  border: none;
  min-height: 0px;
  padding-bottom: 0px;
}
#mc_embed_signup .button {
  background-color: #e23c45;
  border-radius: 0px 8px 8px 0px;
}
#mc_embed_signup input.email {
  border-radius: 8px 0px 0px 8px;
  &::placeholder {
    color: lightgray;
  }
}
@media (max-width: 768px) {
  #mc_embed_signup input.email {
    width: 100%;
    margin-bottom: 5px;
    border-radius: 4px;
  }
  #mc_embed_signup .clear {
    display: block;
    width: 100%;
  }
  #mc_embed_signup .button {
    width: 100%;
    margin: 0;
    border-radius: 8px;
  }
}
</style>
